import { WaysCustomCell } from './components/ways-custom-cell';
import { getStringOperators } from '../../utils/getStringOperators';
import { getNumericOperators } from '../../utils/getNumericOperators';

export const TABLE_COLUMNS = () => {
	return [
		{
			headerName: '#',
			field: 'id',
			width: 100,
			minWidth: 100,
			align: 'center',
			headerAlign: 'center',
			type: 'number',
			cellClassName: 'id',
			filterOperators: getNumericOperators(),
			renderCell: params => WaysCustomCell(params),
		},
		{
			headerName: 'Название',
			field: 'name',
			flex: 1,
			filterOperators: getStringOperators(),
			renderCell: params => WaysCustomCell(params),
		},
		{
			headerName: 'Адрес отгрузки',
			field: 'address_from',
			sortable: false,
			flex: 2,
			filterOperators: getStringOperators(),
		},
		{
			headerName: 'Дата отгрузки',
			field: 'date_from',
			sortable: false,
			filterable: false,
			width: 200,
			valueGetter: value => {
				if (!value) {
					return value;
				}

				return new Date(value);
			},
			renderCell: params => WaysCustomCell(params),
		},
		{
			headerName: 'Адрес доставки',
			field: 'address_to',
			sortable: false,
			flex: 2,
			filterOperators: getStringOperators(),
		},
		{
			headerName: 'Дата доставки',
			field: 'date_to',
			sortable: false,
			filterable: false,
			width: 200,
			valueGetter: value => {
				if (!value) {
					return value;
				}

				return new Date(value);
			},
			renderCell: params => WaysCustomCell(params),
		},
	];
};

export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';
